export const isAuthorizedUser = (userRoles, allowedRoles) =>
  !!userRoles.find((role) => allowedRoles.includes(role));
